import { IProduceJoinDto, SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import {
  IFetchProduceLogsResultData,
  IProduceAbortPayload,
  IProduceAbortResultData,
  IProduceCheckStatusPayload,
  IProduceFetchLogsPayload,
  IProduceInitResultData,
  IProductionCheckResultData,
} from "../models";

export class ProduceJoinApi {
  static async produceStart(
    payload: IProduceJoinDto,
    abortController?: AbortController,
  ): Promise<SimpleResult<IProduceInitResultData> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/production/produce-init`;
    const response = await Api.post<
      SimpleResult<IProduceInitResultData> | undefined
    >(requestUrl, payload, abortController);

    return response?.data;
  }

  static async produceCheckStatus(
    payload: IProduceCheckStatusPayload,
    abortController?: AbortController,
  ): Promise<SimpleResult<IProductionCheckResultData> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/production/produce-check-status`;
    const response = await Api.post<
      SimpleResult<IProductionCheckResultData> | undefined
    >(requestUrl, payload, abortController);

    return response?.data;
  }

  static async produceCancel(
    payload: IProduceAbortPayload,
    abortController?: AbortController,
  ): Promise<SimpleResult<IProduceAbortResultData> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/production/produce-cancel`;
    const response = await Api.post<
      SimpleResult<IProduceAbortResultData> | undefined
    >(requestUrl, payload, abortController);

    return response?.data;
  }

  static async produceFetchLogs(
    payload: IProduceFetchLogsPayload,
    abortController?: AbortController,
  ): Promise<SimpleResult<IFetchProduceLogsResultData> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/production/produce-fetch-logs`;
    const response = await Api.post<
      SimpleResult<IFetchProduceLogsResultData> | undefined
    >(requestUrl, payload, abortController);

    return response?.data;
  }
}
